import { IStackStyles } from "@fluentui/react";
import { media } from "../../../styles/media";

export const getBannerTitleColumnStyles = (): IStackStyles => {
    return {
        root: {
            selectors: {
                [media.maxS]: {
                    paddingTop: "13px",
                    paddingBottom: "14px"
                },
                [media.minM]: {
                    paddingTop: "24px",
                    paddingBottom: "8px"
                },
                [media.minXl]: {
                    paddingTop: "23px",
                    paddingBottom: "17px"
                }
            }
        }
    };
};

export const getBannerTitleImageStyles = (): IStackStyles => {
    return {
        root: {
            marginRight: "16px",
            selectors: {
                [media.maxS]: {
                    marginRight: "12px"
                }
            }
        }
    };
};

export const getBannerTitleIconStyles = (): IStackStyles => {
    return {
        root: {
            marginRight: "16px",
            selectors: {
                [media.maxS]: {
                    marginRight: "12px"
                }
            }
        }
    };
};
